import React from "react";

const ProjectsSection: React.FC = () => {
  return (
    <section className="projects-wrapper" id="projects">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Architecture Portfolio</h2>
          <p className="section-subtitle">
            Selected end-to-end architectures I have led – from problem framing
            to production rollout.
          </p>
        </div>

        <div className="card-grid">
          {/* Project 1 */}
          <article className="project-card">
            <h3 className="project-title">
              US K-12 Assessment Platform – AWS, Java, React, Redshift
            </h3>
            <p className="project-body">
              Principal architect for a cloud-native scoring and reporting
              platform processing millions of student assessments for US school
              districts.
            </p>
            <ul className="project-list">
              <li>
                Designed microservices on ECS Fargate behind API Gateway &amp;
                CloudFront.
              </li>
              <li>
                Data lake on S3 with Redshift, Spectrum &amp; Glue catalog for
                analytics and reporting.
              </li>
              <li>
                Event-driven workflows using Step Functions, SQS and Lambda for
                scoring pipelines.
              </li>
              <li>
                Improved batch turnaround from days to hours and reduced
                operational incidents.
              </li>
            </ul>
          </article>

          {/* Project 2 */}
          <article className="project-card">
            <h3 className="project-title">
              Retail Analytics &amp; Promotions Engine – Kafka, Microservices,
              MongoDB
            </h3>
            <p className="project-body">
              Designed a streaming architecture to personalise offers and
              pricing for a large multi-brand retailer in the Middle East.
            </p>
            <ul className="project-list">
              <li>
                Kafka-centric event backbone with consumer microservices in
                Java/Spring Boot.
              </li>
              <li>
                Rule-driven promotions engine with MongoDB &amp; Redis for
                low-latency decisions.
              </li>
              <li>
                Deployed on Kubernetes with GitLab CI/CD, autoscaling and
                blue-green releases.
              </li>
              <li>
                Drove uplift in campaign conversion and near real-time insights
                for business teams.
              </li>
            </ul>
          </article>

          {/* Project 3 */}
          <article className="project-card">
            <h3 className="project-title">
              Gen-AI Assistant for Education Analytics – Bedrock, Python, React
            </h3>
            <p className="project-body">
              Architecture for an AI assistant enabling educators to query
              Redshift-backed dashboards conversationally using LLMs.
            </p>
            <ul className="project-list">
              <li>
                Secure RAG architecture using AWS Bedrock, Redshift, S3 and
                Lambda with strict data-scoping.
              </li>
              <li>
                Embedding store and metadata-driven access aligned with user
                roles and tenants.
              </li>
              <li>
                React-based chat UI with streaming responses and chart
                suggestions.
              </li>
              <li>
                Prototype used as a reference pattern for future AI initiatives
                in the organisation.
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
